import MobileServiceClient from '@mocobaas/client-js/build/MobileServiceClient';
import { GetListParams, GetListResult, GetOneParams, GetOneResult, UpdateManyParams, UpdateManyResult, UpdateParams, UpdateResult } from 'react-admin';
import gql from 'graphql-tag';
import { ProviderBase } from './ProviderBase';
import { buildArgs } from './utils';
import { dataProvider } from '.';
export class ServicesProductProviderClass extends ProviderBase<any> {
  client: MobileServiceClient;

  constructor(client: MobileServiceClient) {
    super();
    this.client = client;
  }

  async getList(resource: string, params: GetListParams): Promise<GetListResult> {
    const where: Record<string, any> = {};
    const filterArray: any[] = [];
    
    if (params.filter.item_group && Array.isArray(params.filter.item_group)) {
      filterArray.push({
        item_group: {
          _in: params.filter.item_group,
        },
      });
    } else if (params.filter.item_group) {
      filterArray.push({
        item_group: {
          _ilike: `%${params.filter.item_group}%`,
        },
      });
    }

    if (params.filter.item_key) {
      filterArray.push({
        item_key: {
          _ilike: `%${params.filter.item_key}%`,
        },
      });
    }

    if (params.filter.isMvno) {
      filterArray.push({
        is_mvno: {
          _eq: params.filter.isMvno === 'true',
        },
      });
    }

    if (params.filter.isVas) {
      filterArray.push({
        is_vas: {
          _eq: params.filter.isVas === 'true',
        },
      });
    }
    if (params.filter.id) {
      const {
        data: { item_group: itemGroup },
      } = await dataProvider.getOne('productCatalogsItemGroup', {
        id: params.filter.id,
      });
      filterArray.push({
        item_group: {
          _eq: itemGroup,
        },
      });
    }
    if (params.filter.label) {
      filterArray.push({
        label: {
          _ilike: `%${params.filter.label}%`,
        },
      });
    }
    if (params.filter.item_keys) {
      filterArray.push({
        item_key: {
          _in: params.filter.item_keys,
        },
      });
    }
    if (params.filter.country) {
      filterArray.push({
        product_pricings_product_catalog_id_list: {
          country: {
            _eq: params.filter.country,
          },
        },
      });
    }
    if (params.filter.mgp_price) {
      filterArray.push({
        product_pricings_product_catalog_id_list: {
          value: {
            _lte: params.filter.mgp_price,
          },
        },
      });
    }
    if (filterArray.length > 0) where._and = filterArray;

    const { page, perPage } = params.pagination;
    let { field, order } = params.sort;
    const args = buildArgs({
      // @ts-ignore
      order: order || 'ASC',
      size: perPage,
      pageNumber: page,
      sort: field || 'item_group',
    });
    const queryResult = await this.client.gql.query({
      query: gql`
        query ServicesProductList($where: ProductCatalogsWhereInput) {
          allProductCatalogsList(where: $where, ${args}) {
            data {
              id
              created_at
              updated_at
              item_key
              item_group
              label
              description
              retail_price
              inquiry_rules
              execution_rules
              is_available
              is_vas
              is_mvno
              vas_sync_time
              vas_sync_detail
              auto_enabled
              metadata
              country
            }
            count
          }
        }
      `,
      variables: {
        where,
      },
    });
    return {
      data: queryResult?.allProductCatalogsList?.data,
      total: queryResult?.allProductCatalogsList?.count,
    };
  }

  async getOne(resource: string, params: GetOneParams): Promise<GetOneResult> {
    console.log({ method: 'getOne', resource, params });

    const queryResult = await this.client.gql.query({
      query: gql`
        query aServiceProduct($id: UUID!) {
          getProductCatalogsById(id: $id) {
            id
            created_at
            updated_at
            item_key
            item_group
            label
            description
            retail_price
            inquiry_rules
            execution_rules
            is_available
            is_vas
            vas_sync_time
            vas_sync_detail
            auto_enabled
            metadata
            country
            product_pricings_product_catalog_id_list {
              data {
                id
                created_at
                updated_at
                product_catalog_id
                country
                schema
                active
                value
              }
            }
          }
        }
      `,
      variables: {
        id: params.id,
      },
    });

    return { data: queryResult?.getProductCatalogsById };
  }

  async update(resource: string, params: UpdateParams<any>): Promise<UpdateResult<any>> {
    console.log({ method: 'update', resource, params });
    const toBeUpdatedData: any = {
      ...params.data,
      retail_price: Number(params.data.retail_price),
    };
    delete toBeUpdatedData.created_at;
    delete toBeUpdatedData.updated_at;
    delete toBeUpdatedData.id;
    delete toBeUpdatedData.product_pricings_product_catalog_id_list;
    const queryResult = await this.client.gql.mutation({
      mutation: gql`
        mutation ($ids: [UUID!]!, $input: ProductCatalogsUpdateInput!) {
          updateProductCatalogsById(ids: $ids, input: $input) {
            id
            item_key
            item_group
            label
            description
            retail_price
            inquiry_rules
            execution_rules
            is_available
            auto_enabled
            metadata
            country
          }
        }
      `,
      variables: {
        ids: [`${params.id}`],
        input: toBeUpdatedData,
      },
    });

    return { data: queryResult?.updateProductCatalogsById[0] } as UpdateResult;
  }

  async updateMany(resource: string, params: UpdateManyParams<any>): Promise<UpdateManyResult<any>> {
    console.log({ method: 'updateMany', resource, params });
    const toBeUpdatedData: any = {
      ...params.data,
      // @ts-ignore
      constraint_id: params?.data?.constraint_id,
    };
    delete toBeUpdatedData.created_at;
    delete toBeUpdatedData.updated_at;
    delete toBeUpdatedData.id;
    delete toBeUpdatedData.product_pricings_product_catalog_id_list;
    const queryResult = await this.client.gql.mutation({
      mutation: gql`
        mutation ($ids: [UUID!]!, $input: ProductCatalogsUpdateInput!) {
          updateProductCatalogsById(ids: $ids, input: $input) {
            id
            item_key
            item_group
            label
            description
            retail_price
            inquiry_rules
            execution_rules
            constraint_id
            is_available
            auto_enabled
            metadata
            country
          }
        }
      `,
      variables: {
        // @ts-ignore
        ids: params?.ids,
        input: toBeUpdatedData,
      },
    });

    return {
      data: [queryResult?.updateProductCatalogsById[0]],
    } as UpdateManyResult;
  }
}
